import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDvrKD4n0HYKWnMBt0bOFAg9rtcGCRIU8Q",
  authDomain: "event-innovation-lab.firebaseapp.com",
  projectId: "event-innovation-lab",
  storageBucket: "event-innovation-lab.firebasestorage.app",
  messagingSenderId: "162799387567",
  appId: "1:162799387567:web:a094f50eff74de9a1f655a",
  measurementId: "G-8YYK7PZ3L8"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app, "dge-vma");
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope("https://www.googleapis.com/auth/drive");
googleProvider.addScope("https://www.googleapis.com/auth/calendar");
googleProvider.addScope("https://www.googleapis.com/auth/spreadsheets");